<template>
	<div @click="handleClick">
		<div class="flex items-center gap-x-3">
			<template v-if="option.icon">
				<Component
					:is="option.icon?.component"
					v-bind="option.icon?.bindings"
					class="size-6"
				/>
			</template>

			<span
				v-if="typeof option.label === 'string'"
				class="text-sm font-normal leading-[21px] text-white"
			>
				{{ option.label }}
			</span>
			<Component :is="option.label" v-else />
		</div>
	</div>
</template>

<script setup lang="ts">
import { handleEventProps } from '~/composables/events/headerEvents';
import { type NavDefaultOptionConfig } from '.';
import { useEvents } from '~/composables/events/useEvents';
const { trackHeader } = useEvents();

const handleClick = () =>
	handleEventProps(
		props.option.eventProps,
		trackHeader.handleEventMenuHeaderClick
	);

const props = defineProps<{
	option: NavDefaultOptionConfig;
}>();
</script>
